import React from 'react';

import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';

import Dialog from 'shared/dialog';
import { nonClosingProps } from 'bundles/apex/tasks/task_modal/helpers';

interface Props {
  show: boolean;
  onDelete: () => void;
  onHide: () => void;
}

export default function AttachmentDeletionConfirmation({ show, onDelete, onHide }: Props) {
  return (
    <Dialog
      buttonType="danger"
      confirmLabel="Delete"
      headerText="Delete Attachment"
      icon={faExclamationCircle}
      iconClassName="text-danger"
      show={show}
      onConfirm={onDelete}
      onHide={onHide}
      {...nonClosingProps}
    >
      <h3 className="m-0">Are you sure you want to delete this attachment?</h3>
    </Dialog>
  );
}
